import { render, staticRenderFns } from "./EditScopeOfPracticeCategoryModal.vue?vue&type=template&id=31aa4ee0&scoped=true&"
import script from "./EditScopeOfPracticeCategoryModal.vue?vue&type=script&lang=js&"
export * from "./EditScopeOfPracticeCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aa4ee0",
  null
  
)

export default component.exports